"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_components_1 = require("@apollo/react-components");
var component_modal_1 = require("@doordash/component-modal");
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var App_1 = __importDefault(require("../../App/App"));
var RiskModal_1 = __importDefault(require("../../Common/RiskModal"));
var apollo_1 = require("../../Common/utils/apollo");
var SecurityUpdateIcon_1 = __importDefault(require("../Icons/SecurityUpdateIcon"));
var VerifyAccountStyles_1 = require("../VerifyAccountStyles");
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var PhoneEmailVerificationStrings_1 = __importDefault(require("./PhoneEmailVerificationStrings"));
var renderHeader = function (title) { return (React.createElement(design_language_1.StackChildren, null,
    React.createElement(VerifyAccountStyles_1.SecurityIconContainer, null,
        React.createElement(SecurityUpdateIcon_1["default"], { size: design_language_1.Icon.Sizes.XLarge, color: design_language_1.Colors.SystemWhite })),
    React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageTitle, textAlign: design_language_1.Text.TextAlignments.Center }, title))); };
var PhoneEmailVerifyLayout = function (_a) {
    var children = _a.children, disableDismiss = _a.disableDismiss, requiresPageLayout = _a.requiresPageLayout;
    var _b = React.useContext(App_1["default"]), client = _b.client, language = _b.language, proxyOverride = _b.proxyOverride, authToken = _b.authToken;
    var apolloClient = client || apollo_1.getApolloClient(language, proxyOverride, authToken);
    var modalTitle = PhoneEmailVerificationStrings_1["default"].verifyYourAccount();
    return requiresPageLayout ? (React.createElement(react_components_1.ApolloProvider, { client: apolloClient },
        React.createElement(design_language_1.StackChildren, null,
            renderHeader(modalTitle),
            children))) : (React.createElement(RiskModal_1["default"], { disableDismiss: disableDismiss, onCloseTracking: VerifyAccountTracking_1.trackOnClose, size: component_modal_1.Modal.Sizes.Small, title: modalTitle, renderContentHeader: function (_a) {
            var title = _a.title;
            return renderHeader(title);
        } }, function () { return React.createElement(React.Fragment, null, children); }));
};
exports["default"] = PhoneEmailVerifyLayout;
